function _Events() {
    // Get a list of the events
    const events = document.querySelectorAll('.event-item');

    // For each event
    for (let x = 0; x < events.length; x++) {
        // Get the date/time information
        const eventDateAndTime = events[x].querySelector(
            '.event-item-date-time-value'
        );
        let eventDateAndTimeInnerHTML = eventDateAndTime.innerHTML;
        // replace any instance of " am " with "am "
        eventDateAndTimeInnerHTML = eventDateAndTimeInnerHTML.replace(
            / am /g,
            'am '
        );
        // replace any instance of " pm " with "pm "
        eventDateAndTimeInnerHTML = eventDateAndTimeInnerHTML.replace(
            / pm /g,
            'pm '
        );

        eventDateAndTime.innerHTML = eventDateAndTimeInnerHTML;
    }
}

_Events();
